module.exports = __webpack_public_path__ + "ea83fdb7da1dbb33277a81e08388186b.pdf";